 
$(document).ready(function(){
    $("body").on("click", ".open-popup", function () {
    $(".member-popup").addClass("open");
  });

  $("body").on("click", ".member-close", function () {
    $(".member-popup").removeClass("open");
  });

   $("body").on("click", ".cart-drawer-container, cart-remove-button,button ,.product-form__submit ", function (){

      setTimeout(function() { 
           if ($('a.link.product-title:contains("Membership Program")').length > 0) {
          $(".open-popup").addClass("hide");
           $(".checkout-pop").addClass("show");  
      }
     else{
        $(".open-popup").removeClass("hide");
           $(".checkout-pop").removeClass("show"); 
     }
    }, 2000);
     

  });

$("body").on("click", ".color__swatch", function (){

      setTimeout(function() {   
            var text = $('.product__info-container .memberretailer-box .retailer-box span bdi').text().replace("$", "");
          var textcommahide = text.replace(",", "");
           var textint = parseInt(textcommahide); 
          var textoff = textint - (textint * 25 / 100);
          var textoffsign = "$" + textoff; 
            $('.product__info-container .memberretailer-box .member-box span').text(textoffsign);  
    }, 900); 
  });
  

if (localStorage.getItem("iswrpdivloaded") === null) {
   console.log("showPopup");  
   $(".promo-popup").removeClass("dontShowPopup");
localStorage.setItem('iswrpdivloaded', 1);
}


});

  //$(document).ready(function() {
   // $('form[action="/cart/add"]').submit(function() { 
      // Check if the product being added to the cart matches the specific product
     // if ($('input[name="id"]').val() == '44512222773563') {
        // Apply the discount code to the cart 
       // $.ajax({
       // type: 'POST',
      //  url: '/cart/update.js',
       // data: {
        //  discount: {
         //   key: 'memberdiscounts'
         // }
       // },
       // dataType: 'json',
       // success: function(cart) {
        //  console.log('Discount applied to cart');
          // You can update the cart totals or redirect to the cart page here
       // },
       // error: function(XMLHttpRequest, textStatus) {
         // console.log('Error applying discount to cart: ' + textStatus);
        //}
     // });
        
      //}
   // });
  //});